/**
 * governance/utils/tierRequirements.ts
 * Tier-aware minimum content requirements.
 *
 * NOTE: These constants are deprecated — use getMinExplanationLength/getMinDistractorLength
 * from pipeline/policyEngine.ts instead. The canonical source of truth is defaultPolicy.ts.
 * Kept here only for barrel re-export compatibility.
 */

/** @deprecated Use getMinExplanationLength from pipeline/policyEngine.ts instead. */
export const TIER_MIN_EXPLANATION_LENGTH: Record<string, number> = {
  basic: 30, // Tiers 1-4
  intermediate: 50, // Tiers 5-8
  advanced: 80, // Tiers 9-12
  expert: 100, // Tiers 13-16
}

/** @deprecated Use getMinDistractorLength from pipeline/policyEngine.ts instead. */
export const TIER_MIN_DISTRACTOR_LENGTH: Record<string, number> = {
  basic: 15,
  intermediate: 25,
  advanced: 35,
  expert: 45,
}

/**
 * @deprecated Use getTierBand from pipeline/policyEngine.ts instead.
 * Kept only for barrel re-export compatibility.
 */
export function getTierBandKey(tier: number): string {
  if (tier <= 4) return 'basic'
  if (tier <= 8) return 'intermediate'
  if (tier <= 12) return 'advanced'
  return 'expert'
}
